import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Feature } from './Feature';
import { AppConfig } from '../../../../assets/config/appconfig';
import { AppInsightsService } from '../appinsights/appinsights.service';

@Injectable()
export class FeaturesService {
  private featureURL = `${this._appConfig.settings.defaultURL}/V2/feature/`;
  constructor(private http: HttpClient, private _appConfig: AppConfig, private appInsightsService: AppInsightsService) {
  }

  getFeature(): Observable<Feature>{
    const httpOptions = { headers : new HttpHeaders({ 'Content-Type': 'application/json' })};
    let url = `${this.featureURL}`;
    this.appInsightsService.logEvent(`Calling feature endpoint: ${url}`);
    return this.http.get<Feature>(url, httpOptions);
  }
}
